var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 4.99996,
    r: 3.33333,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.726 19.9853C16.2073 19.9853 18.2187 17.9739 18.2187 15.4927C18.2187 13.0114 16.2073 11 13.726 11C11.2448 11 9.2334 13.0114 9.2334 15.4927C9.2334 17.9739 11.2448 19.9853 13.726 19.9853ZM14.2251 13.2463C14.2251 12.9706 14.0016 12.7471 13.7259 12.7471C13.4502 12.7471 13.2267 12.9706 13.2267 13.2463V14.9935H11.4795C11.2039 14.9935 10.9804 15.2169 10.9804 15.4926C10.9804 15.7683 11.2039 15.9918 11.4795 15.9918H13.2267V17.739C13.2267 18.0147 13.4502 18.2381 13.7259 18.2381C14.0016 18.2381 14.2251 18.0147 14.2251 17.739V15.9918H15.9722C16.2479 15.9918 16.4714 15.7683 16.4714 15.4926C16.4714 15.2169 16.2479 14.9935 15.9722 14.9935H14.2251V13.2463Z",
    fill: "#697586"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.318 10.8383C10.2126 10.8355 10.1066 10.8341 9.99992 10.8341C6.31802 10.8341 3.33325 12.513 3.33325 14.5841C3.33325 16.5255 3.33325 18.1223 8.82456 18.3147C8.30168 17.4616 8.00024 16.4581 8.00024 15.3842C8.00024 13.515 8.91344 11.8591 10.318 10.8383Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/addUser.f3fa117602c204712b162e79ff773fc3.svg";
export { ForwardRef as ReactComponent };